console.log("from firebase: ", process.env);
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_API_KEY,
//     authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_APP_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyBEleK1YZu97iKtj8sCHkd7DGDXVnPqynU",
  authDomain: "sabuj-portfolio.firebaseapp.com",
  projectId: "sabuj-portfolio",
  storageBucket: "sabuj-portfolio.appspot.com",
  messagingSenderId: "374422193909",
  appId: "1:374422193909:web:5a859ba7013fa8571fa7bc",
};
export default firebaseConfig;
